import { defineStore } from 'pinia'
import mitt from 'mitt'
import { Emitter, EventType } from 'mitt'

export const useEventBusStore = defineStore('EventBus', {
    state: (): Emitter<Record<EventType, unknown>> => mitt(),
})
